import SitecoreTextModel from '@models/SitecoreTextModel';

const TEXT_ARR = ['Would Not Recommend Text', 'Read More Text', 'Recommend Text', 'Show More Review Text', 'Read Less Text'];

export default class MyReviewsModel {
  constructor() {
    TEXT_ARR.forEach((item) => {
      this[item] = new SitecoreTextModel();
    });
  }

  getData(dataSource) {
    TEXT_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item].getData(dataSource[item]);
      }
    });

    return this;
  }
}
